import React from "react";

import t from "../../../Common/utils/translation/translator";

import AxisSelectionTableHeader from "./AxisSelectionTableHeader";

const AxisSelectionTableHeadersSection = ({
  productExpand,
  technicalFeatureExpand,
  performanceOverviewExpand,
  guidingSystemExpand,
  mechanics,
  productTableHeaders,
  technicalFeaturesTableHeaders,
  performanceOverviewTableHeaders,
  getGuidingSystemTableHeaders,
  ...props
}) => {
  const renderHeaders = (headers, isExpanded) =>
    headers
      .map((header, index) => (
        <AxisSelectionTableHeader
          data-testid={`axis-selection-table-header-${header.name}`}
          key={header.name}
          title={header.name}
          colNumber={index + 1}
          isSort={header.sort}
          hasUnitHeader
          unit={header.unit}
          headers={headers}
          subHeaders={header.subHeaders}
          mechanics={mechanics}
          productTableHeaders={productTableHeaders}
          technicalFeaturesTableHeaders={technicalFeaturesTableHeaders}
          performanceOverviewTableHeaders={performanceOverviewTableHeaders}
          getGuidingSystemTableHeaders={getGuidingSystemTableHeaders}
        />
      ))
      .filter((_, index) => isExpanded || index === 0); // Only render the first header if collapsed
  return (
    <tr className="AxisSelectionTableHeadersSection" {...props}>
      <AxisSelectionTableHeader
        data-testid="axis-selection-table-header-product"
        title={t("cartesian.ui.axis_selection.product")}
        colNumber={0}
        isSort
        mechanics={mechanics}
        productTableHeaders={productTableHeaders}
        technicalFeaturesTableHeaders={technicalFeaturesTableHeaders}
        performanceOverviewTableHeaders={performanceOverviewTableHeaders}
        getGuidingSystemTableHeaders={getGuidingSystemTableHeaders}
      />
      {renderHeaders(productTableHeaders, productExpand)}
      {renderHeaders(technicalFeaturesTableHeaders, technicalFeatureExpand)}
      {renderHeaders(performanceOverviewTableHeaders, performanceOverviewExpand)}
      {renderHeaders(getGuidingSystemTableHeaders(mechanics.quantityCarriages), guidingSystemExpand)}
      <AxisSelectionTableHeader
        data-testid="axis-selection-table-header-select"
        title={t("cartesian.ui.axis_selection.select")}
        colNumber={
          productTableHeaders.length +
          technicalFeaturesTableHeaders.length +
          performanceOverviewTableHeaders.length +
          getGuidingSystemTableHeaders(mechanics.quantityCarriages).length +
          1
        }
        mechanics={mechanics}
        productTableHeaders={productTableHeaders}
        technicalFeaturesTableHeaders={technicalFeaturesTableHeaders}
        performanceOverviewTableHeaders={performanceOverviewTableHeaders}
        getGuidingSystemTableHeaders={getGuidingSystemTableHeaders}
      />
    </tr>
  );
};

export default AxisSelectionTableHeadersSection;
